// These are written to the window via wwwroot/public/config/appEnv.js
// on deployment, appEnv.js may get overwritten by the appropriate environment values, 
// but by default it is set to dev.
function getEnvironmentVariables() {
	return window.AppEnv;
}

export default getEnvironmentVariables;